import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-apply-incentive-modal',
  templateUrl: './apply-incentive-modal.component.html',
  styleUrls: ['./apply-incentive-modal.component.css']
})
export class ApplyIncentiveModalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
  closeModal(){}
}
